import { useIndentButton } from "@platejs/indent/react";
import { ButtonWrapper } from "./_Button";
import FontAwesome from "../../../utilities/FontAwesome";

export function IndentButton() {
  const { props: buttonProps } = useIndentButton();

  return (
    <ButtonWrapper {...buttonProps} tooltip={"Indent"}>
      <FontAwesome fixedWidth prefix={"fas"} name={"fa-indent"} />
    </ButtonWrapper>
  );
}
